import type { CSSProperties } from "react";

export type IvScoreStyle = CSSProperties & {
  "--iv-score-severity-color"?: string;
  "--fintheon-directional-cap-light-source"?: string;
};

export function environmentLabel(score: number): string {
  if (score >= 8) return "Shit Show";
  if (score >= 6) return "Tipping Point";
  if (score >= 4) return "Gathering Storm";
  if (score >= 2) return "Light Winds";
  return "Calm Seas";
}

export function fuseSegmentColor(segmentIndex: number): string {
  if (segmentIndex >= 8) return "var(--fintheon-severe)";
  if (segmentIndex >= 6) return "var(--fintheon-high)";
  if (segmentIndex >= 4) return "var(--fintheon-neutral-severe)";
  if (segmentIndex >= 2) return "var(--fintheon-low)";
  return "var(--fintheon-bullish)";
}

export function urgencyClass(urgency: string): string {
  if (urgency === "extreme") return "text-[var(--fintheon-severe)]";
  if (urgency === "high") return "text-[var(--fintheon-high)]";
  if (urgency === "elevated") return "text-[var(--fintheon-neutral-severe)]";
  if (urgency === "moderate") return "text-[var(--fintheon-accent)]";
  return "text-[var(--fintheon-low)]";
}

export function vixPulseStyle(vixLevel: number): IvScoreStyle {
  if (vixLevel >= 22) return severityPulse("var(--fintheon-severe)", "1.5s");
  if (vixLevel >= 16) return severityPulse("var(--fintheon-high)", "2s");
  if (vixLevel >= 14)
    return severityPulse("var(--fintheon-neutral-severe)", "2.5s");
  return severitySource("var(--fintheon-low)");
}

export function directionPulseStyle(direction: "up" | "down"): IvScoreStyle {
  return {
    ...severitySource(
      direction === "down"
        ? "var(--fintheon-bullish)"
        : "var(--fintheon-bearish)",
    ),
    animation: "vix-direction-pulse 1.5s ease-in-out",
  };
}

export function capLightStyle(source: string): IvScoreStyle {
  return { "--fintheon-directional-cap-light-source": source };
}

export function installIvScoreKeyframes(): void {
  const id = "vix-pulse-keyframes";
  if (typeof document === "undefined" || document.getElementById(id)) return;
  const style = document.createElement("style");
  style.id = id;
  style.textContent = `
    @keyframes vix-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.6; } }
    @keyframes vix-direction-pulse { 0% { opacity: 1; } 30% { opacity: 0.5; } 60% { opacity: 1; } 80% { opacity: 0.7; } 100% { opacity: 1; } }
    @keyframes vix-value-flash { 0% { opacity: 1; } 50% { opacity: 0.4; } 100% { opacity: 1; } }
  `;
  document.head.appendChild(style);
}

function severityPulse(source: string, duration: string): IvScoreStyle {
  return {
    ...severitySource(source),
    animation: `vix-pulse ${duration} ease-in-out infinite`,
  };
}

function severitySource(source: string): IvScoreStyle {
  return {
    "--iv-score-severity-color": source,
    "--fintheon-directional-cap-light-source": source,
  };
}
